<script lang="ts" setup>
import { extension } from 'mime-types'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{ src?: string | File, collectionId?: string, id?: string, alt?: string, theme?: string }>()
const url = ref()
const loaded = ref(false)
onMounted(async () => {
  if (props.src instanceof File) {
    const d = await readUploadedFileAsImage(src)
    url.value = d.src
  }
  loaded.value = true
})

const computedFilename = computed(() => {
  const baseFileName = 'gbf-' + new Date().toISOString()

  if (!props.src || typeof props.src !== 'string' || !props.src.startsWith('data:')) return `${baseFileName}`

  const mimeMatch = props.src?.match(/^data:([^;]+);/)
  if (!mimeMatch) return `${baseFileName}`

  const mime = mimeMatch[1]
  const ext = extension(mime) // returns e.g. 'pdf', 'txt', etc.

  return `${baseFileName}.${ext || 'file'}`
})

const buttonColours = computed(() => getButtonColor(props.theme))
</script>

<template>
  <div
    class="w-full h-full"
  >
    <template v-if="loaded && collectionId && id && src">
      <!-- <NuxtPicture :src="getImagePath({ collectionId, id, src })" :alt="alt" :img-attrs="$attrs" /> -->
      <a
        :href="getImagePath({ collectionId, id, src, direct: true })"
        target="_blank"
        class="flex flex-col items-center justify-center gap-1 rounded shadow  text-xl py-3"
        :class="buttonColours.button"
      ><Icon
        name="ri:download-cloud-2-line"
        :class="buttonColours.icon"
        class="text-xl lg:text-2xl"
      />
        Download
      </a>
    </template>

    <a
      v-else-if="!url && loaded"
      :href="src"
      class="flex flex-col items-center justify-center gap-1 rounded shadow  text-xl py-3"
      :class="buttonColours.button"
      :download="computedFilename"
    ><Icon
      name="ri:download-cloud-2-line"
      :class="buttonColours.icon"
      class="text-xl lg:text-2xl"
    />
      Downloads
    </a>
  </div>
</template>

<style scoped>
.pink{
  @apply bg-pink text-white;
}
.blue{
  @apply bg-blue text-white;
}
.yellow{
  @apply bg-yellow text-white;
}
.light-blue{
  @apply bg-light-blue text-white;
}
</style>
